export function addQueryParameterToUri(uri, key, value) {
  let queryDelimiterPosition = uri.indexOf('?');
  let includeQueryDelimiter = queryDelimiterPosition === -1;
  let segmentDelimiterPosition = uri.indexOf('#');
  let insertAt = segmentDelimiterPosition !== -1 ?
      segmentDelimiterPosition :
      uri.length;

  let queryToInsert = (includeQueryDelimiter ? "?" : "&") + key + "=" + value;
  return uri.substring(0, insertAt) + queryToInsert + uri.substring(insertAt + 1)
}

export function getQueryParameterValueFromUri(uri, key) {
  let url = new URL(uri);
  return url.searchParams.get(key);
}
